import { GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GridRowHeightParams } from '@mui/x-data-grid-premium';
import { defineRowHeight } from '../../../../../shared/helpers/utils/utils.helper';

export const AGGREGATION_FOOTER_ROW_HEIGHT = 52;

export const getOrderGridRowHeight = ({ id, model }: GridRowHeightParams): number =>
  id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID
    ? AGGREGATION_FOOTER_ROW_HEIGHT
    : defineRowHeight(model.indTextDeliveryNote);
